import { ProductImagesTab } from './ProductImagesTab';

export default ProductImagesTab;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductImagesTab/index.ts